<template>
  <v-container fluid>
    <v-row justify="space-between" class="px-10">
      <v-col cols="12" sm="12" md="4">
        <p class="text-h6 text--secondary font-weight-bold">
          Push Notifications
        </p>
      </v-col>
      <v-col cols="12" sm="12" md="3">
        <v-btn text color="secondary" @click="openPushNotificationModal()">
          <v-icon left dark color="primary"> mdi-plus-circle </v-icon>
          Create New Push Notification
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="5">
        <v-text-field
          label="Search for a Push Notification"
          v-model="search"
          single-line
          outlined
          rounded
          filled
          dense
          append-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="search"
          :loading="loading"
          :headers="headers"
          :items="getPushNotifications"
          item-key="id"
          fixed-header
          class="elevation-4"
        >
          <template v-slot:[`item.message`]="{ item }">
            <span
              class="d-block text-truncate mx-auto"
              style="max-width: 550px !important"
            >
              {{ item.message }}
            </span>
          </template>
          <template v-slot:[`item.segment`]="{ item }">
            <v-chip
              :color="getSegmentColor(item.segment)"
              text-color="white"
              small
            >
              {{ getSegmentDisplayName(item.segment) }}
            </v-chip>
          </template>
          <template v-slot:[`item.image`]="{ item }">
            <div class="d-flex align-center justify-center">
              <v-icon
                v-if="item.image"
                color="success"
                size="24"
                @click="previewImage(item.image)"
                style="cursor: pointer"
                title="Click to preview image"
              >
                mdi-image
              </v-icon>
              <v-icon v-else color="grey" size="24"> mdi-image-off </v-icon>
            </div>
          </template>
          <template v-slot:[`item.createdAt`]="{ item }">
            <span class="text-caption">
              {{ formatDate(item.createdAt) }}
            </span>
          </template>
          <template v-slot:[`item.updatedAt`]="{ item }">
            <span class="text-caption">
              {{ formatDate(item.updatedAt) }}
            </span>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn
              icon
              color="primary"
              class="mr-3"
              @click="editPushNotification(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              icon
              color="red"
              class="mr-3"
              @click="openModalConfirm(item, 'delete')"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-btn icon color="primary" @click="openModalConfirm(item, 'send')">
              <v-icon>mdi-send</v-icon>
            </v-btn>
          </template>
          <!-- <template v-slot:footer="{}">
            <v-row justify="end">
              <v-col cols="1">
                <v-select
                  class="mr-auto"
                  v-model="itemsPerPage"
                  :items="[5,10,15,20,30]"
                >
              </v-select>
              </v-col>
              <v-col cols="2" class="text-right mr-3" align-self="center">
              <v-btn color="primary" x-small class="mx-1" :disabled="pageCounter === 1" @click="goPrevPagePushNotifications()">
                <v-icon size="15">
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <p class="d-inline">{{ pageCounter }}</p>
              <v-btn color="primary" x-small class="mx-1" :disabled="getPushNotifications.length < itemsPerPage || getPushNotifications.length === 0" @click="goNextPagePushNotifications()">
                <v-icon size="15">
                  mdi-arrow-right
                </v-icon>
              </v-btn>
              </v-col>
            </v-row>
          </template> -->
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog.show" width="300" class="rounded-xl">
      <v-card class="text-center" v-if="dialog.type === 'send'">
        <!-- <v-card-title class="headline">Use Google's location service?</v-card-title> -->
        <v-icon class="text-center ma-2" size="120" color="primary"
          >mdi-alert</v-icon
        >
        <v-card-text class="pa-4 text-center"
          >With this action you will send a mass notification to all users of
          MAXPRO</v-card-text
        >
        <v-card-text class="text-center">Are you sure?</v-card-text>

        <!-- <v-card-actions class="pa-0"> -->
        <!-- <v-spacer></v-spacer> -->

        <v-btn
          color="third"
          tile
          width="150"
          class="pa-0 text--secondary"
          @click="closeModalConfirm()"
          >No</v-btn
        >

        <v-btn
          color="primary"
          tile
          width="150"
          class="pa-0"
          @click="openDialogReAuth('sendPushNotification', dialog.item)"
          >Yes</v-btn
        >
        <!-- </v-card-actions> -->
      </v-card>
      <v-card class="text-center" v-if="dialog.type === 'delete'">
        <!-- <v-card-title class="headline">Use Google's location service?</v-card-title> -->
        <v-icon class="text-center ma-2" size="100" color="primary"
          >mdi-delete</v-icon
        >
        <v-card-text class="pa-4 text-center"
          >Are you sure to delete this notification?</v-card-text
        >
        <!-- <v-card-text class="text-center">Are you sure?</v-card-text> -->

        <!-- <v-card-actions class="pa-0"> -->
        <!-- <v-spacer></v-spacer> -->

        <v-btn
          color="third"
          tile
          width="150"
          class="pa-0 text--secondary"
          @click="closeModalConfirm()"
          >No</v-btn
        >
        <v-btn
          color="primary"
          tile
          width="150"
          class="pa-0"
          @click="openDialogReAuth('deletePushNotification', dialog.item)"
          >Yes</v-btn
        >
        <!-- </v-card-actions> -->
      </v-card>
    </v-dialog>
    <modal-reauth
      :dialogReAuth="dialogReAuth"
      @isSuccessReAuth="isSuccessReAuth"
    ></modal-reauth>
    <PushNotificationModal
      :dialog="pushNotificationDialog"
      :editMode="pushNotificationDialog.editMode"
      :editData="pushNotificationDialog.editData"
      @notificationCreated="handleNotificationCreated"
      @notificationUpdated="handleNotificationUpdated"
      @dialogClosed="handleDialogClosed"
    />

    <!-- Image Preview Dialog -->
    <v-dialog v-model="imagePreviewDialog.show" max-width="600">
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-image</v-icon>
          Image Preview
          <v-spacer></v-spacer>
          <v-btn icon @click="imagePreviewDialog.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="text-center pa-4">
          <v-img
            :src="imagePreviewDialog.imageUrl"
            max-height="400"
            contain
            class="mx-auto"
          ></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="imagePreviewDialog.show = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar.snackbar" :color="snackbar.color">{{
      snackbar.text
    }}</v-snackbar>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import modalReauth from "@/components/admin/modal-reauth.vue";
import PushNotificationModal from "@/components/admin/push-notification-modal.vue";

export default {
  components: { modalReauth, PushNotificationModal },
  name: "PushNotifications",
  data: () => ({
    pushNotificationDialog: {
      show: false,
      editMode: false,
      editData: null,
    },
    imagePreviewDialog: {
      show: false,
      imageUrl: "",
    },
    dialogReAuth: {
      show: false,
      action: "",
      item: {},
    },
    snackbar: {
      snackbar: false,
      timeout: 2000,
      text: null,
      color: "",
    },
    dialog: {
      show: false,
      item: "",
      type: "",
    },
    itemsPerPage: 10,
    pageCounter: 1,
    search: "",
    loading: false,
    headers: [
      { text: "Title", align: "center", value: "title", sortable: true },
      { text: "Message", align: "center", value: "message", sortable: true },
      { text: "Link", align: "center", value: "link", sortable: true },
      {
        text: "Target Segment",
        align: "center",
        value: "segment",
        sortable: true,
      },
      { text: "Image", align: "center", value: "image", sortable: true },
      { text: "Created", align: "center", value: "createdAt", sortable: true },
      { text: "Updated", align: "center", value: "updatedAt", sortable: true },
      { text: "", align: "center", value: "action", sortable: false },
    ],
  }),
  created() {
    let vm = this;
    vm.getPushNotificationsList();
  },
  methods: {
    getPushNotificationsList() {
      let vm = this;
      vm.loading = true;
      vm.$store
        .dispatch("GetNotifications")
        .then((res) => {
          vm.loading = false;
        })
        .catch((err) => {
          vm.loading = false;
        });
    },
    getFirstPagePushNotifications() {
      let vm = this;
      vm.$store
        .dispatch("GetPushNotificationsPaginatedFirstPage", vm.itemsPerPage)
        .then((res) => {
          vm.pageCounter = 1;
          vm.loading = false;
        })
        .catch((err) => {
          console.error(err);
          vm.loading = false;
        });
    },
    goNextPagePushNotifications() {
      let vm = this;
      vm.$store
        .dispatch("GetPushNotificationsNextPage", vm.itemsPerPage)
        .then((res) => {
          if (res.length > 0) {
            vm.pageCounter = vm.pageCounter + 1;
          }
          vm.loading = false;
        })
        .catch((err) => {
          console.error(err);
          vm.loading = false;
        });
    },
    goPrevPagePushNotifications() {
      let vm = this;
      vm.$store
        .dispatch("GetPushNotificationsPrevPage", vm.itemsPerPage)
        .then((res) => {
          vm.pageCounter = vm.pageCounter - 1;
          vm.loading = false;
        })
        .catch((err) => {
          console.error(err);
          vm.loading = false;
        });
    },
    isSuccessReAuth(dialogReAuthResponse) {
      const vm = this;
      switch (dialogReAuthResponse.action) {
        case "deletePushNotification":
          vm.deletePushNotification(dialogReAuthResponse.item);
          break;
        case "sendPushNotification":
          vm.sendPushNotification(dialogReAuthResponse.item);
          break;
        default:
          break;
      }
    },
    openDialogReAuth(action, item) {
      let vm = this;
      vm.dialogReAuth.show = true;
      vm.dialogReAuth.action = action;
      vm.dialogReAuth.item = item;
      vm.closeModalConfirm();
    },
    editPushNotification(item) {
      let vm = this;
      vm.pushNotificationDialog.editMode = true;
      vm.pushNotificationDialog.editData = item;
      vm.pushNotificationDialog.show = true;
    },
    createPushNotification() {
      let vm = this;
      vm.openPushNotificationModal();
    },
    deletePushNotification(item) {
      let vm = this;
      vm.$store
        .dispatch("DeleteNotification", item)
        .then((id) => {
          vm.$store.dispatch("GenerateLog", {
            id: id,
            title: item.title,
            type: "deletedPushNotification",
          });
          let emitData = {
            snackbar: true,
            btn: "",
            y: "bottom",
            x: null,
            mode: "",
            timeout: 2000,
            text: "Notification deleted succesfully!",
            color: "success",
          };
          vm.$emit("showSnackBar", emitData);
          vm.getPushNotificationsList();
        })
        .catch((err) => {
          let emitData = {
            snackbar: true,
            btn: "",
            y: "bottom",
            x: null,
            mode: "",
            timeout: 2000,
            text: "Error deleting notification!",
            color: "error",
          };
          vm.$emit("showSnackBar", emitData);
          // vm.messageSnack(`Error deleting notification`, "error");
        });
    },
    sendPushNotification(pushNotification) {
      let vm = this;
      vm.$emit("showOverlay", true);
      vm.$store
        .dispatch("SendNotificationBySegment", pushNotification)
        .then((res) => {
          vm.$store.dispatch("GenerateLog", {
            id: pushNotification.id,
            title: pushNotification.title,
            type: "sendedPushNotification",
          });
          vm.$emit("showOverlay", false);
          let emitNotification = {
            snackbar: true,
            btn: "",
            y: "bottom",
            x: null,
            mode: "",
            timeout: 2000,
            text: "Notification massive sended succesfully!",
            color: "success",
          };
          vm.$emit("showSnackBar", emitNotification);
        })
        .catch((err) => {
          vm.$emit("showOverlay", false);
          let emitError = {
            snackbar: true,
            btn: "",
            y: "bottom",
            x: null,
            mode: "",
            timeout: 2000,
            text: "Notification massive error!",
            color: "red",
          };
          vm.$emit("showSnackBar", emitError);
        });
    },
    openModalConfirm(item, type) {
      let vm = this;
      vm.dialog.show = true;
      vm.dialog.item = item;
      vm.dialog.type = type;
    },
    closeModalConfirm() {
      let vm = this;
      vm.dialog.show = false;
      vm.dialog.item = "";
      vm.dialog.type = "";
    },
    openPushNotificationModal() {
      let vm = this;
      vm.pushNotificationDialog.editMode = false;
      vm.pushNotificationDialog.editData = null;
      vm.pushNotificationDialog.show = true;
    },
    handleNotificationCreated(notificationId) {
      let vm = this;
      vm.getPushNotificationsList();
      let emitData = {
        snackbar: true,
        btn: "",
        y: "bottom",
        x: null,
        mode: "",
        timeout: 2000,
        text: "Notification created successfully!",
        color: "success",
      };
      vm.$emit("showSnackBar", emitData);
    },
    handleNotificationUpdated(notificationId) {
      let vm = this;
      vm.getPushNotificationsList();
      let emitData = {
        snackbar: true,
        btn: "",
        y: "bottom",
        x: null,
        mode: "",
        timeout: 2000,
        text: "Notification updated successfully!",
        color: "success",
      };
      vm.$emit("showSnackBar", emitData);
    },
    handleDialogClosed() {
      let vm = this;
      // Reset edit mode when modal is closed
      vm.pushNotificationDialog.editMode = false;
      vm.pushNotificationDialog.editData = null;
    },
    getSegmentColor(segment) {
      switch (segment) {
        case "All":
          return "primary";
        case "Premium Users":
          return "success";
        case "Free Users":
          return "warning";
        default:
          return "grey";
      }
    },
    getSegmentDisplayName(segment) {
      switch (segment) {
        case "All":
          return "All Users";
        case "Premium Users":
          return "Premium";
        case "Free Users":
          return "Free";
        default:
          return segment || "Unknown";
      }
    },
    previewImage(imageUrl) {
      let vm = this;
      vm.imagePreviewDialog.show = true;
      vm.imagePreviewDialog.imageUrl = imageUrl;
    },
    formatDate(date) {
      if (!date) return 'N/A';
      
      // Handle Firestore timestamp objects
      if (date.toDate) {
        date = date.toDate();
      }
      
      // Handle string dates
      if (typeof date === 'string') {
        date = new Date(date);
      }
      
      // Check if it's a valid date
      if (isNaN(date.getTime())) {
        return 'N/A';
      }
      
      // Format as MM/DD/YYYY HH:MM
      const options = {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      };
      
      return date.toLocaleDateString('en-US', options);
    },
  },
  destroyed() {
    let vm = this;
    // vm.$store.dispatch("GoUnsuscribeGetPushNotifications");
  },
  computed: {
    ...mapGetters(["getPushNotifications"]),
  },
  // watch:{
  //   itemsPerPage:{
  //     handler(newValue){
  //       this.getFirstPagePushNotifications()
  //     }
  //   }
  // }
};
</script>
<style scoped>
.v-data-table /deep/ .sticky-header {
  position: sticky;
  top: var(--toolbarHeight);
}

.v-data-table /deep/ .v-data-table__wrapper {
  overflow: unset;
}
</style>